import { AnyAction } from 'redux';
import { GetReportRecipient } from '../types/reportRecipient';
import { CustomerOption } from '../types/customerOption';

interface ReportRecipientsState {
  reportRecipients: GetReportRecipient[];
  reportRecipientsLoading: boolean;
  selectedCustomer: CustomerOption;
}

const initialState: ReportRecipientsState = {
  reportRecipients: [],
  reportRecipientsLoading: false,
  selectedCustomer: { value: 0, label: '' },
};

export default function reducer(state: ReportRecipientsState = initialState, action: AnyAction): ReportRecipientsState {
  switch (action.type) {
    case 'SET_REPORT_RECIPIENTS_LOADING': {
      return {
        ...state,
        reportRecipientsLoading: action.payload,
      };
    }
    case 'SET_REPORT_RECIPIENTS': {
      return {
        ...state,
        reportRecipients: action.payload,
      };
    }
    case 'ADD_REPORT_RECIPIENT': {
      return {
        ...state,
        reportRecipients: [...state.reportRecipients, action.payload],
      };
    }
    case 'REMOVE_REPORT_RECIPIENT': {
      return {
        ...state,
        reportRecipients: state.reportRecipients.filter(
          (item) =>
            !(
              item.email === action.payload.email &&
              item.customer.id === action.payload.customerId
            )
        ),
      };
    }
    case 'SET_SELECTED_REPORT_RECIPIENT_CUSTOMER': {
      return {
        ...state,
        selectedCustomer: action.payload,
      };
    }

    default:
      return {
        ...state,
      };
  }
}
